import React, { useEffect } from 'react';
import { SEO } from '@/components/SEO';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { useGameMode } from '@/contexts/GameModeContext';
import { Calendar, Dices, Flame } from 'lucide-react';
import { streakManager } from '@/components/game/managers/StreakManager';

const Index = () => {
  const navigate = useNavigate();
  const { switchToMode } = useGameMode();
  const { currentStreak } = streakManager.getStreakState();
  const rank = streakManager.getCurrentRank();

  // Check for shared sequences on index page
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const hasSharedSequence = !!urlParams.get('sequence');
    
    if (hasSharedSequence) {
      console.log('Shared sequence detected on index page, redirecting to game');
      navigate('/game');
    }
  }, [navigate]);

  const handlePlayDaily = async () => {
    await switchToMode('daily', true);
    navigate('/game');
  };

  const handlePlayPractice = async () => {
    await switchToMode('practice', true);
    navigate('/game');
  };

  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center p-4">
      <SEO
        title="Choose Game Mode | BabbleGram"
        description="Pick Daily Challenge or Practice mode and start playing BabbleGram, the daily word puzzle."
        path="/modes"
      />
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          <h1 className="text-3xl font-bold text-white mb-2">Select Game Mode</h1>
          <p className="text-gray-400">Choose how you want to play Babblegram</p>
        </div>

        <div className="space-y-4">
          {currentStreak > 0 && (
            <div className="flex items-center justify-center gap-2 text-sm text-gray-300">
              <Flame className="h-4 w-4 text-[#de0046]" />
              <span>
                {currentStreak} day streak
                {rank ? ` · ${rank}` : ''}
              </span>
            </div>
          )}
          <Button
            onClick={handlePlayDaily}
            className="w-full h-16 bg-red-600 hover:bg-red-700 text-white flex items-center justify-center gap-3 text-lg"
          >
            <Calendar className="h-6 w-6" />
            <div className="text-left">
              <div className="font-semibold">Daily Challenge</div>
              <div className="text-sm opacity-90">One puzzle per day</div>
            </div>
          </Button>

          <Button
            onClick={handlePlayPractice}
            className="w-full h-16 bg-purple-600 hover:bg-purple-700 text-white flex items-center justify-center gap-3 text-lg"
          >
            <Dices className="h-6 w-6" />
            <div className="text-left">
              <div className="font-semibold">Practice Mode</div>
              <div className="text-sm opacity-90">Unlimited puzzles</div>
            </div>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Index;